module.exports = __webpack_public_path__ + "static/img/3.03ddf85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-pt/3.jpg
// module id = 7ngJ
// module chunks = 1